export class DelayBetweenOrderAndDelivery {
    ID: number;
    Name: string;
}

export default DelayBetweenOrderAndDelivery;